export const approveStatus = (section) => {
    return {
        type: 'APPROVE_SECTION',
        payload: section
    }
};
export const rejectStatus = (section) => {
    return {
        type: 'REJECT_SECTION',
        payload: section
    }
};

export const toggleTab = (tab) => {
    return {
        type: "TOGGLE_TAB",
        payload: tab
    };
}
export const toggleModal = (status) => {
    return {
        type: "TOGGLE_MODAL",
        payload: status
    };
}
export const VIEW_ALL_CASES = 'src/Component/Cases/List/View_All';
export const VIEW_ALL_CASES_SUCCESS = 'src/Component/Cases/List/View_All_Success';
export const VIEW_ALL_CASES_FAIL = 'src/Component/Cases/List/View_All_Fail';

export const viewAllCases = (data) => {
    return {
        type: VIEW_ALL_CASES,
        data
    };
}
export const viewAllCasesSuccess = (data) => {
    return {
        type: VIEW_ALL_CASES_SUCCESS,
        data
    };
}
export const viewAllCasesFail = (data) => {
    return {
        type: VIEW_ALL_CASES_FAIL,
        data
    };
}

export const VIEW_PAGINATED_CASES = 'src/Component/Cases/List/View_Paginated';
export const VIEW_PAGINATED_CASES_SUCCESS = 'src/Component/Cases/List/View_Paginated_Success';
export const VIEW_PAGINATED_CASES_FAIL = 'src/Component/Cases/List/View_Paginated_Fail';
export const viewPaginatedCases = (data) => {
    return {
        type: VIEW_PAGINATED_CASES,
        data
    };
}
export const viewPaginatedCasesSuccess = (data) => {
    return {
        type: VIEW_PAGINATED_CASES_SUCCESS,
        data
    };
}
export const viewPaginatedCasesFail = (data) => {
    return {
        type: VIEW_PAGINATED_CASES_FAIL,
        data
    };
}

export const viewAllSections = (data) => {
    return {
        type: "VIEW_ALL_SECTIONS",
        data
    };

}

export const DOWNLOAD_PENDING_CASES = 'src/Analyst/Cases/List/Action/DOWNLOAD_PENDING_CASES';
export const DOWNLOAD_PENDING_CASES_SUCCESS = 'src/Analyst/Cases/List/Action/DOWNLOAD_PENDING_CASES_SUCCESS';
export const DOWNLOAD_PENDING_CASES_FAILURE = 'src/Analyst/Cases/List/Action/DOWNLOAD_PENDING_CASES_FAILURE';
export const downloadPendingCases = (data) => {
    return {
        type: DOWNLOAD_PENDING_CASES,
        data
    };
}
export const downloadPendingCasesSuccess = (data) => {
    return {
        type: DOWNLOAD_PENDING_CASES_SUCCESS,
        data
    };
}
export const downloadPendingCasesFailure = (data) => {
    return {
        type: DOWNLOAD_PENDING_CASES_FAILURE,
        data
    };
}

export const GET_ALL_SECTIONS = 'src/components/cases/List/Action/Get_All_Sections'
export const getAllSections = (data) => {
    return {
        type: GET_ALL_SECTIONS,
        data
    }
}
export const addTabs = (template) => {
    return {
        type: "ADD_TABS",
        payload: template
    };

}

export const toggleDropdown = () => {

    return {
        type: "TOGGLE_DROPDOWN"
    };

}

export const FETCH_CORPORATE_NAME = 'src/Analyst/Cases/List/Actions/Fetch_Corporate_Name';
export const FETCH_CORPORATE_NAME_SUCCESS = 'src/Analyst/Cases/List/Actions/Fetch_Corporate_Name_Success';
export const FETCH_CORPORATE_NAME_FAILURE = 'src/Analyst/Cases/List/Actions/Fetch_Corporate_Name_Failure';

export const getCorporateName = () => {
    return {
        type: FETCH_CORPORATE_NAME
    }
}
export const getCorporateNameSuccess = (data) => {
    return {
        type: FETCH_CORPORATE_NAME_SUCCESS,
        data
    }
}
export const getCorporateNameFailure = (data) => {
    return {
        type: FETCH_CORPORATE_NAME_FAILURE,
        data
    }
}

export const FETCH_PRODUCTS_BY_CORPORATES = 'src/Analyst/Cases/List/Actions/Fetch_Products_By_Corporates';
export const FETCH_PRODUCTS_BY_CORPORATES_SUCCESS = 'src/Analyst/Cases/List/Actions/Fetch_Products_By_Corporates_Success';
export const FETCH_PRODUCTS_BY_CORPORATES_FAILURE = 'src/Analyst/Cases/List/Actions/Fetch_Products_By_Corporates_Failure';

export const fetchProductsByCorporates = (corporateIds) => {
    return {
        type: FETCH_PRODUCTS_BY_CORPORATES,
        data: corporateIds
    }
}
export const fetchProductsByCorporatesSuccess = (data) => {
    return {
        type: FETCH_PRODUCTS_BY_CORPORATES_SUCCESS,
        data
    }
}
export const fetchProductsByCorporatesFailure = (data) => {
    return {
        type: FETCH_PRODUCTS_BY_CORPORATES_FAILURE,
        data
    }
}

// export const GET_CASE_EPF_DETAILS = 'src/components/Cases/View/action/Get_Case_EPF_Details';
// export const CASE_DETAILS_EPF_SUCCESS = 'src/components/Cases/View/action/Case_Details_EPF_Success';
// export const CASE_DETAILS_EPF_FAILURE = 'src/components/Cases/View/action/Case_Details_EPF_Failure';
// export const getCaseEPFDetails = (data) => {
//     return {
//         type: GET_CASE_EPF_DETAILS,
//         data
//     }
// }
// export const caseDetailsEPFSuccess = (data) => {
//     return {
//         type: CASE_DETAILS_EPF_SUCCESS,
//         data
//     }
// }
// export const caseDetailsEPFFailure = (data) => {
//     return {
//         type: CASE_DETAILS_EPF_FAILURE,
//         data
//     }
// }